import routes from "./routes.json";

export const ORIGIN = "https://asadoxperience.com";
export const LANGS = ["es", "en"];
export const DEFAULT_LANG = routes.defaultLang;
export const PAGES = routes.pages;

/** Normaliza a la forma canónica: siempre con barra final (es la que sirve nginx). */
export function normalize(pathname) {
  if (!pathname) return "/";
  const clean = pathname.split("?")[0].split("#")[0];
  return clean.endsWith("/") ? clean : `${clean}/`;
}

/** El idioma sale de la URL, no del navegador: es lo único que Google puede ver. */
export function langFromPath(pathname) {
  const p = normalize(pathname);
  return p === "/en/" || p.startsWith("/en/") ? "en" : "es";
}

/** La entrada de PAGES que corresponde a una URL, o null si es una ruta sin traducción (admin, booking). */
export function pageFromPath(pathname) {
  const p = normalize(pathname);
  return PAGES.find((page) => LANGS.some((l) => page[l] === p)) || null;
}

/** La misma página en el otro idioma. Si la ruta no está traducida, cae a la home de ese idioma. */
export function pathForLang(pathname, lang) {
  const page = pageFromPath(pathname);
  if (page) return page[lang];
  return PAGES[0][lang];
}

/** Ruta de una página por id (ver routes.json) en el idioma dado. Para enlaces internos. */
export function pathFor(id, lang) {
  const page = PAGES.find((p) => p.id === id);
  return page ? page[lang] : "/";
}

/** Alternates de la ruta actual, para <link rel="alternate" hreflang>. */
export function alternatesFor(pathname) {
  const page = pageFromPath(pathname);
  if (!page) return [];
  return [
    ...LANGS.map((l) => ({ hreflang: l, href: `${ORIGIN}${page[l]}` })),
    { hreflang: "x-default", href: `${ORIGIN}${page[DEFAULT_LANG]}` },
  ];
}
